function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M3.5 5.06v13.88c0 .41-.34.75-.75.75S2 19.35 2 18.94V5.06c0-.41.34-.75.75-.75s.75.34.75.75zm18.5 0v13.88c0 .41-.34.75-.75.75s-.75-.34-.75-.75V5.06c0-.41.34-.75.75-.75s.75.34.75.75zM8 21.25h8c1.66 0 3-1.34 3-3V5.75c0-1.66-1.34-3-3-3H8c-1.66 0-3 1.34-3 3v12.5c0 1.66 1.34 3 3 3z"
})));